import { Button, Modal, Stack } from '@mantine/core'
import { IconDownload } from '@tabler/icons-react'
import { getTermsVersion } from './contractTermsVersions'

interface ContractTermsModalProps {
  opened: boolean
  onClose: () => void
  termsVersion?: string | null
}

export function ContractTermsModal({
  opened,
  onClose,
  termsVersion,
}: ContractTermsModalProps) {
  const terms = getTermsVersion(termsVersion)

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Sopimusehdot – Markku.fi Pientalopalvelut"
      size="xl"
      centered
    >
      <Stack gap="md">
        {terms.content}

        <Button
          component="a"
          href={terms.pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="light"
          leftSection={<IconDownload size={16} />}
          fullWidth
          mt="md"
        >
          Lataa sopimusehdot (PDF)
        </Button>

        <Button fullWidth onClick={onClose} color="brandOrange">
          Sulje
        </Button>
      </Stack>
    </Modal>
  )
}
